/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Lookup_Delete_Terms_TitleInputs */

const en_knp_lookup_delete_terms_title = /** @type {(inputs: Knp_Lookup_Delete_Terms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete selected terms`)
};

const fr_knp_lookup_delete_terms_title = /** @type {(inputs: Knp_Lookup_Delete_Terms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer les termes selectionnes`)
};

const de_knp_lookup_delete_terms_title = /** @type {(inputs: Knp_Lookup_Delete_Terms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewählte Begriffe löschen`)
};

const it_knp_lookup_delete_terms_title = /** @type {(inputs: Knp_Lookup_Delete_Terms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina i termini selezionati`)
};

const ru_knp_lookup_delete_terms_title = /** @type {(inputs: Knp_Lookup_Delete_Terms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить выбранные термины`)
};

const es_knp_lookup_delete_terms_title = /** @type {(inputs: Knp_Lookup_Delete_Terms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar términos seleccionados`)
};

const zh_cn2_knp_lookup_delete_terms_title = /** @type {(inputs: Knp_Lookup_Delete_Terms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除选定的条款`)
};

const ja_knp_lookup_delete_terms_title = /** @type {(inputs: Knp_Lookup_Delete_Terms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択した用語を削除`)
};

const hi_knp_lookup_delete_terms_title = /** @type {(inputs: Knp_Lookup_Delete_Terms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित शब्दों को हटाएँ`)
};

const pt_pt2_knp_lookup_delete_terms_title = /** @type {(inputs: Knp_Lookup_Delete_Terms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir termos selecionados`)
};

/**
* | output |
* | --- |
* | "Delete selected terms" |
*
* @param {Knp_Lookup_Delete_Terms_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_delete_terms_title = /** @type {((inputs?: Knp_Lookup_Delete_Terms_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_Delete_Terms_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_lookup_delete_terms_title(inputs)
	if (locale === "de") return de_knp_lookup_delete_terms_title(inputs)
	if (locale === "it") return it_knp_lookup_delete_terms_title(inputs)
	if (locale === "ru") return ru_knp_lookup_delete_terms_title(inputs)
	if (locale === "es") return es_knp_lookup_delete_terms_title(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_lookup_delete_terms_title(inputs)
	if (locale === "ja") return ja_knp_lookup_delete_terms_title(inputs)
	if (locale === "hi") return hi_knp_lookup_delete_terms_title(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_lookup_delete_terms_title(inputs)
	return en_knp_lookup_delete_terms_title(inputs)
});